import { Td, Checkbox, Flex } from "@chakra-ui/react";

export function TdCheckbox({
  value,
  onChange,
}: {
  value?: boolean;
  onChange?: (value: boolean) => void;
}) {
  return (
    <Td onClick={e => e.stopPropagation()} w="36px" aria-label="Select item">
      <Flex justifyContent="center" alignItems="center" h="100%">
        <Checkbox
          colorScheme="teal"
          isChecked={value}
          onChange={e => onChange?.(e.target.checked)}
          onClick={e => e.stopPropagation()}
        />
      </Flex>
    </Td>
  );
}
